import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'icp-text',
  standalone: true,
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
})
export class TextComponent {
  @Input() color?: string;
  @Input() size?: string;
  @Input() weight?: string;
  @Input() align: 'left' | 'center' | 'right' = 'left';
  @Input() truncate = false;
  @Input() lines?: number;

  @HostBinding('style.color') get sColor() {
    return this.color || null;
  }
  @HostBinding('style.font-size') get sSize() {
    return this.size || null;
  }
  @HostBinding('style.font-weight') get sWeight() {
    return this.weight || null;
  }
  @HostBinding('style.text-align') get sAlign() {
    return this.align || null;
  }
  @HostBinding('class.truncate') get cTruncate() {
    return !!this.truncate && !this.lines;
  }
  @HostBinding('style.display') get sDisplay() {
    return this.lines ? '-webkit-box' : null;
  }
  @HostBinding('style.-webkit-line-clamp') get sClamp() {
    return this.lines ? String(this.lines) : null;
  }
  @HostBinding('style.-webkit-box-orient') get sOrient() {
    return this.lines ? 'vertical' : null;
  }
  @HostBinding('style.overflow') get sOverflow() {
    return this.truncate || this.lines ? 'hidden' : null;
  }
}
